// extracted by mini-css-extract-plugin
module.exports = {"blocked":"c_c","loader":"c_d","blog":"c_f","blog__categoryItem__wrap":"c_g"};